import { StackBase, TypographyBase } from '@fmc-digital/ui';
import { CustomContentProps, SnackbarContent } from 'notistack';
import React, { forwardRef, memo } from 'react';

declare module 'notistack' {
    interface VariantOverrides {
        SnackbarLoader: true;
    }
}

interface SnackbarLoaderBaseProps extends CustomContentProps {
    message?: string;
}

const SnackbarLoaderBaseComponent = forwardRef<HTMLDivElement, SnackbarLoaderBaseProps>(({ message, ...props }, ref) => {
    return (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        <SnackbarContent ref={ref} {...props}>
            <StackBase display={'flex'} borderRadius={'1rem'} padding={'0.5rem'} width={'100%'} sx={{ bgcolor: '#00476a' }}>
                <TypographyBase px={'0.5rem'} fontSize={'0.8125rem'} color={'primary.contrastText'} width={'100%'} fontFamily={'Poppins'}>
                    {message}
                </TypographyBase>
            </StackBase>
        </SnackbarContent>
    );
});
SnackbarLoaderBaseComponent.displayName = 'SnackbarLoaderBaseComponent';
export const SnackbarLoaderBase = memo(SnackbarLoaderBaseComponent);
